import { render, staticRenderFns } from "./VideoReviewDialog.vue?vue&type=template&id=897d5312&scoped=true&"
import script from "./VideoReviewDialog.vue?vue&type=script&lang=js&"
export * from "./VideoReviewDialog.vue?vue&type=script&lang=js&"
import style0 from "./VideoReviewDialog.vue?vue&type=style&index=0&id=897d5312&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897d5312",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('897d5312')) {
      api.createRecord('897d5312', component.options)
    } else {
      api.reload('897d5312', component.options)
    }
    module.hot.accept("./VideoReviewDialog.vue?vue&type=template&id=897d5312&scoped=true&", function () {
      api.rerender('897d5312', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/VideoReviewDialog.vue"
export default component.exports